import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { TravelTypes } from '../constants';
import useBrochureOptionRemoval from './useBrochureOptionRemoval';
import getBrochureTripId from '../helpers/getBrochureTripId';
import { addToBrochure } from '../store/slices/brochure';

const useHandleCarRentalAddToBrochure = ({
  tripId,
  carItinerary,
  brochure,
  isViewingBrochure,
  isBrochurePage,
  currentBrochure,
  brochureOnBrochurePage,
  selectedTab,
  tripRoomSearchInput,
}) => {
  const { staterooms } = useSelector((store) => store.tripSearch.searchObj);
  const id = getBrochureTripId(
    tripId,
    brochure,
    carItinerary,
    tripRoomSearchInput || staterooms,
    TravelTypes.carrental,
  );

  const findHotelItineraryByKeyAndDates = (tripSegments, uniqueKey) =>
    _.find(
      tripSegments,
      (ts) =>
        ts.itinerary.uniqueKey === uniqueKey &&
        ts.itinerary?.startDateTime === carItinerary?.startDateTime &&
        ts.itinerary?.endDateTime === carItinerary?.endDateTime,
    );
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const handleSegmentRemoval = useBrochureOptionRemoval();
  const handleAddToBrochureClick = (event) => {
    if (event && event.type === 'keydown' && event.key !== 'Enter') return;
    if (!carItinerary) return;
    const handleSegmentRemovalWrapper = (brochureId, brochureToUpdate, isSavedToDatabase) => {
      handleSegmentRemoval({
        brochureId,
        currentBrochure: brochureToUpdate,
        travelType: TravelTypes.carrental,
        segmentKey: 'uniqueKey',
        segmentKeyValue: carItinerary.uniqueKey,
        findTripSegmentfn: findHotelItineraryByKeyAndDates,
        isSavedToDatabase,
        itinerary: carItinerary,
        staterooms: tripRoomSearchInput,
      });
    };
    if (isBrochurePage && brochureOnBrochurePage && tripId) {
      const brochureToUpdate = JSON.parse(JSON.stringify(brochureOnBrochurePage));
      handleSegmentRemovalWrapper(tripId, brochureToUpdate, true);
      return;
    }
    if (isViewingBrochure && !_.isNil(currentBrochure)) {
      const brochureId = brochure && brochure.id;
      const isSavedToDatabase = brochure && brochure.isSavedToDatabase;
      handleSegmentRemovalWrapper(brochureId, currentBrochure, isSavedToDatabase);
      handleSegmentRemoval({
        brochureId: brochure.id,
        currentBrochure,
        travelType: TravelTypes.carrental,
        segmentKeyValue: carItinerary.uniqueKey,
        segmentKey: 'uniqueKey',
        findTripSegmentfn: findHotelItineraryByKeyAndDates,
        isSavedToDatabase: brochure.isSavedToDatabase,
      });
    }
    let updatedTrip = { tripSegments: [] };
    if (brochure && brochure.trips && brochure.trips[id]) {
      // Clone brochure, we can not update brochure value
      updatedTrip = JSON.parse(JSON.stringify(brochure.trips[id]));
    }

    let action = 'add';
    const tripSeg = findHotelItineraryByKeyAndDates(
      updatedTrip.tripSegments,
      carItinerary.uniqueKey,
    );
    if (!tripSeg) {
      updatedTrip.tripSegments.push({
        itinerary: {
          ...carItinerary,
          id: selectedTab,
        },
      });
    } else {
      _.remove(
        updatedTrip.tripSegments,
        (ts) => ts.itinerary.uniqueKey === tripSeg.itinerary.uniqueKey,
      );
      action = 'remove';
    }
    dispatch(
      addToBrochure({
        tripId: id,
        updatedTrip,
        staterooms,
      }),
    );
    track(`RentalCarBrochure.${action}`, { uniqueKey: carItinerary?.uniqueKey });
  };
  return handleAddToBrochureClick;
};

export default useHandleCarRentalAddToBrochure;
